import type { FC } from 'react';
import { Grid } from '@mui/material';

import type { IConnectAccountFormValues } from './ConnectForm';
import { ConnectForm } from './ConnectForm';
import { WelcomeSideBar } from '../general/WelcomeSideBar';
import { useTranslation } from 'react-i18next';
import { ConnectionStatus } from '@pflegenavi/service-provider-shared/api-endpoints';
import { AlreadyAcceptedInfo } from '../general/AlreadyAcceptedInfo';

interface ConnectAccountContentProps {
  companyDetails: {
    name: string;
    address: string;
    city: string;
    zipCode: string;
    phone: string;
    countryId: string;
  };
  userDetails: {
    firstName: string;
    lastName: string;
  };
  countryOptions: Array<{
    label: string;
    value: string;
  }>;
  loading: boolean;
  accountAffiliationName?: string;
  connectionStatus?: ConnectionStatus;
  handleConnectAccount: (
    values: IConnectAccountFormValues,
    responseToInvitation?: boolean
  ) => Promise<void>;
}

export const ConnectAccountContent: FC<ConnectAccountContentProps> = ({
  companyDetails,
  userDetails,
  countryOptions,
  loading,
  accountAffiliationName,
  connectionStatus,
  handleConnectAccount,
}) => {
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid
        size={{
          md: 3,
        }}
      >
        <WelcomeSideBar
          title={t('service-provider-app.connect-account.hello')}
          subtitle={t(
            'service-provider-app.connect-account.welcome-to-pflegenavi'
          )}
        />
      </Grid>
      <Grid
        size={{
          md: 9,
        }}
      >
        {connectionStatus &&
        connectionStatus !== ConnectionStatus.InvitePending &&
        accountAffiliationName ? (
          <AlreadyAcceptedInfo
            connectionStatus={connectionStatus}
            accountAffiliationName={accountAffiliationName}
          />
        ) : (
          <ConnectForm
            companyDetails={companyDetails}
            userDetails={userDetails}
            countryOptions={countryOptions}
            accountAffiliationName={accountAffiliationName}
            handleConnectAccount={handleConnectAccount}
            loading={loading}
          />
        )}
      </Grid>
    </Grid>
  );
};
